import styled from 'styled-components';

import { mediaWide } from '@xing-com/layout-tokens';
import { spaceXXL, spaceM, spaceS, spaceXL } from '@xing-com/tokens';

import { Headline } from '../headline';
import { ProfileContactsWithProduct } from '../profile-contacts-with-product';

import { BestSellerFlag } from './best-seller-flag';
import { OfferBoxCard } from './offer-box-card';
import { OfferBoxPicker } from './offer-box-picker';
import { PricingBox } from './pricing-box';
import { PurchaseButton } from './purchase-button';
import type { PurchaseStickyBarProps } from './purchase-sticky-bar';

export const PurchaseStickyBarBase: React.FC<PurchaseStickyBarProps> = (
  props
) => {
  const {
    contracts,
    product,
    id,
    toggleContract,
    isBestSeller,
    price,
    disabled,
    orderType,
    duration,
    premiumContacts,
    showFacepile,
  } = props;
  return (
    <StickyWrapper>
      <OfferBoxCard $product={product}>
        <StyledHeadline product={product} />
        <BestSellerWrapper>
          <StyledMobileBestSellerFlag
            product={product}
            visible={isBestSeller}
          />
          {showFacepile && premiumContacts && (
            <ProfileContactsWithProduct
              renderLocation="offerbox"
              premiumContacts={premiumContacts}
              isInRow
            />
          )}
        </BestSellerWrapper>
        <StyledDesktopBestSellerFlag product={product} visible={isBestSeller} />
        <StyledPricingBox price={price} />
        <StyledOfferBoxPicker
          product={product}
          contracts={contracts}
          activeContractId={id}
          onContractChange={toggleContract}
        />
        <PurchaseButton
          disabled={disabled}
          product={product}
          orderType={orderType}
          id={id}
          duration={duration}
        />
      </OfferBoxCard>
    </StickyWrapper>
  );
};

const StickyWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;

  @media ${mediaWide} {
    width: 350px;
    top: 150px;
    bottom: initial;
    left: initial;
  }
`;

const StyledMobileBestSellerFlag = styled(BestSellerFlag)`
  display: inline;

  @media ${mediaWide} {
    display: none;
  }
`;

const StyledDesktopBestSellerFlag = styled(BestSellerFlag)`
  display: none;

  @media ${mediaWide} {
    display: block;
  }
`;

const StyledHeadline = styled(Headline)`
  margin-bottom: ${spaceXXL};
  display: none;

  @media ${mediaWide} {
    display: block;
  }
`;

const BestSellerWrapper = styled.div`
  display: grid;
  grid-gap: ${spaceM};
  grid-template-columns: auto minmax(0, 1fr);
  margin-bottom: ${spaceM};

  @media ${mediaWide} {
    grid-template-columns: 1fr;
    grid-gap: ${spaceS};
  }

  &:empty {
    display: none;
  }
`;
const StyledPricingBox = styled(PricingBox)`
  margin-bottom: ${spaceXL};
`;

const StyledOfferBoxPicker = styled(OfferBoxPicker)`
  margin-bottom: ${spaceXXL};
  display: none;

  @media ${mediaWide} {
    display: flex;
  }
`;
